export type ProtocolDataType = {
	email: string;
	phoneNumber: string;
};

export enum ModalityCodeEnum {
	MEDICAL_APPOINTMENT = '1',
	SPECIAL_EXAMS = '2',
	SIMPLE_EXAMS = '3',
	HOSPITALIZATIONS = '4',
	EMERGENCY = '5',
	THERAPIES = '6',
}

export type BankDataType = {
	bankCode: string;
	bankName: string;
	agency: string;
	account: string;
	accountDigit?: string;
	agencyDigit?: string;
};

export type FinancialDataType = {
	invoiceAmount: string;
	invoiceNumber: number;
	invoiceType: number;
	invoiceIssueState?: string;
	invoiceIssueCity?: string;
	ibgeDocumentCity?: string;
	invoiceDigit?: string;
};

export type ProfessionalDataType = {
	providerName: string;
	providerCode?: string;
	professionalType: string;
	professionalName: string;
	councilAcronym?: string;
	councilNumber?: string;
	councilState?: string;
	professionalDocument?: string;
};

export type TreatmentDataType = {
	date: string;
	modality: string;
	modalityCode: ModalityCodeEnum;
	beneficiary: {
		code: string;
	};
	planCode?: string;
	specialty: {
		specialtyCodeCbo?: string | null;
		description: string;
		specialtyCode: string;
	};
};

export type RequestData = {
	protocolData: ProtocolDataType;
	bankData: BankDataType;
	professionalData: ProfessionalDataType;
	treatmentData: TreatmentDataType;
	financialData: FinancialDataType;
};

export interface PostRefundCreateRequestParams {
	requestData: RequestData;
}

export interface PostRefundCreateRequestResponse {
	content: {
		protocol: string;
		protocolCode: number;
		request: string;
		requestCode: number;
		status: number;
		message: string;
	};
}

export interface PostRefundCreateRequest {
	post: (params: PostRefundCreateRequestParams) => Promise<PostRefundCreateRequestResponse>;
}
